import React, { useEffect, useState } from 'react';
import { Card,  Col, Nav, CardBody } from "react-bootstrap";

import CustomerVisitasComponent from '../customer/CustomerVisitas'
import CustomerClicksComponent from '../customer/CustomerClicks'
import CustomerPublicidadComponent from '../customer/CustomerPublicidad'
import CustomerOfertasComponent from '../customer/CustomerOfertas'
import CustomerActividadComponent from '../customer/CustomerActividad'


export default function CustomerDataComponent({data,columns}){
  const [activeTab, setActiveTab] = useState('visitas');
  const menu = [
    {id:1,text:'Vistas',type:'visitas'},   
    {id:2,text:'Publicidad',type:'publicidad'},
    {id:3,text:'Ofertas',type:'ofertas'},
    {id:4,text:'Actividad',type:'actividad'},
  ]

  const getIcon = (type) => {
    /*
    switch (type) {
      case 'visitas':
        return <TiAlarmMinus className="me-1" />;      
      case 'clicks':
        return <TiNotes className="me-1" />;
      case 'publicidad':
        return <TiPhone className="me-1" />;
      case 'ofertas':
        return <TiFile className="me-1" />;
      case 'actividad':
        return <TiMailCheck className="me-1" />;
      default:
        return "";      
    }
    */
   return "";
  }

  return(
    <Col xl={9} className="cdp-component">
      <Card>
        <CardBody className="pb-0 pt-2">
          <Nav className="customer-nav" 
            variant="underline" 
            activeKey={activeTab} 
            onSelect={(selectedKey) => setActiveTab(selectedKey)}
          >
           {menu.map((item) => (
              <Nav.Item key={item.id} className='customer-nav-item'>
                <Nav.Link
                  eventKey={item.type}
                  aria-selected={activeTab === item.type}
                  className={'customer-nav-link ' + (activeTab === item.type ? 'active' : '')}
                >
                  {getIcon(item.type)}
                  {item.text}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </CardBody>
      </Card>

      <div>
        <Card>
          <CardBody style={{overflowX:'auto'}}>            
            <CustomerVisitasComponent data={data.articulos} selectedTab={activeTab} />
            <CustomerClicksComponent selectedTab={activeTab} />
            <CustomerPublicidadComponent selectedTab={activeTab} />
            <CustomerOfertasComponent selectedTab={activeTab} />
            <CustomerActividadComponent selectedTab={activeTab} />
          </CardBody>
        </Card>        
      </div>
    </Col>
  )
}